import { render } from "./FormButton.vue?vue&type=template&id=3c8ae78a&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=3c8ae78a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c8ae78a"

export default script